function frFitText(key, fallback, parameters={}) {return (globalThis.FrancieraUiText?.[key] || fallback).replace(/%\{([^}]+)\}/g,(_,name)=>String(parameters[name]??''));}
class LovingSizeGuide {
  constructor() {
    document.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('submit', this.onSubmit.bind(this));
    document.addEventListener('change', this.onMeasurementChange.bind(this), true);
    document.addEventListener('cancel', this.onCancel.bind(this), true);
    document.addEventListener('close', this.onClose.bind(this), true);
  }

  onClick(event) {
    const openButton = event.target.closest('[data-loving-size-guide-open]');
    if (openButton) {
      const modal = document.getElementById(openButton.dataset.lovingSizeGuideOpen);
      if (modal?.showModal) {
        modal.showModal();
        modal.dataset.lovingMeasurementUnit ||= 'cm';
        document.documentElement.classList.add('loving-modal-open');
      }
      return;
    }

    const closeButton = event.target.closest('[data-loving-size-guide-close]');
    if (closeButton) {
      closeButton.closest('[data-loving-size-guide-modal]')?.close();
      return;
    }

    const unitButton = event.target.closest('[data-loving-size-guide-unit]');
    if (unitButton) {
      const context = unitButton.closest('[data-loving-size-recommender], [data-loving-size-guide-modal]');
      this.setUnit(context, unitButton.dataset.lovingSizeGuideUnit);
      return;
    }

    const selectButton = event.target.closest('[data-loving-select-size]');
    if (selectButton) {
      this.selectRecommendedSize(selectButton);
      return;
    }

    const recommendButton = event.target.closest('[data-loving-size-recommend]');
    if (recommendButton) {
      this.calculate(recommendButton.closest('[data-loving-size-recommender-form]'));
      return;
    }

    const modal = event.target.closest('[data-loving-size-guide-modal]');
    if (modal && event.target === modal) modal.close();
  }

  onSubmit(event) {
    const form = event.target.closest('[data-loving-size-recommender-form]');
    if (!form) return;
    event.preventDefault();

    this.calculate(form);
  }

  onMeasurementChange(event) {
    if (event.target?.closest?.('[data-loving-size-recommender-form]')) event.stopPropagation();
  }

  calculate(form) {
    if (!form) return;

    const context = form.closest('[data-loving-size-recommender]');
    if (!context) return;
    const error = context.querySelector('[data-loving-size-error]');
    const result = context.querySelector('[data-loving-size-result]');
    error.hidden = true;

    if (Array.from(form.querySelectorAll('input[required]')).some((input) => !input.value)) {
      error.textContent = frFitText("uacf57682dc6a", "Enter all five measurements before asking for a recommendation.");
      error.hidden = false;
      return;
    }

    try {
      const unit = context.dataset.lovingMeasurementUnit || 'cm';
      const inputs = this.readMeasurements(form, unit);
      this.validateMeasurements(inputs);
      const chart = this.readChart(context, unit);
      const availability = this.readAvailability(context);
      const recommendation = this.recommend(chart, inputs, availability);
      this.renderRecommendation(context, recommendation);
    } catch (caughtError) {
      result.hidden = true;
      error.textContent = caughtError.message || frFitText("uebd30d8e2a01", "We could not calculate a size from this chart. Please contact us for fit help.");
      error.hidden = false;
    }
  }

  onCancel() {
    document.documentElement.classList.remove('loving-modal-open');
  }

  onClose(event) {
    if (event.target.matches?.('[data-loving-size-guide-modal]')) {
      document.documentElement.classList.remove('loving-modal-open');
    }
  }

  setUnit(context, unit) {
    if (!context || !['cm', 'in'].includes(unit)) return;
    const previousUnit = context.dataset.lovingMeasurementUnit || 'cm';
    if (previousUnit !== unit) this.convertFormValues(context, previousUnit, unit);
    context.dataset.lovingMeasurementUnit = unit;

    context.querySelectorAll('[data-loving-size-guide-unit]').forEach((button) => {
      const selected = button.dataset.lovingSizeGuideUnit === unit;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    context.querySelectorAll('[data-loving-size-guide-table]').forEach((table) => {
      const selected = table.dataset.lovingSizeGuideTable === unit;
      table.classList.toggle('is-active', selected);
      table.hidden = !selected;
    });

    context.querySelectorAll('[data-loving-input-unit]').forEach((label) => {
      label.textContent = unit === 'cm' ? label.dataset.unitCm : label.dataset.unitIn;
    });

    context.querySelector('[data-loving-size-result]')?.setAttribute('hidden', '');
    context.querySelector('[data-loving-size-error]')?.setAttribute('hidden', '');
  }

  convertFormValues(context, fromUnit, toUnit) {
    const form = context.querySelector('[data-loving-size-recommender-form]');
    if (!form) return;
    const lengthFactor = fromUnit === 'cm' && toUnit === 'in' ? 1 / 2.54 : 2.54;
    const weightFactor = fromUnit === 'cm' && toUnit === 'in' ? 2.2046226218 : 1 / 2.2046226218;

    ['bust', 'waist', 'hips', 'height'].forEach((name) => {
      const input = form.querySelector(`input[name="${name}"]`);
      if (!input?.value) return;
      input.value = this.roundMeasurement(Number(input.value) * lengthFactor);
    });

    const weight = form.querySelector('input[name="weight"]');
    if (weight?.value) weight.value = this.roundMeasurement(Number(weight.value) * weightFactor);
  }

  roundMeasurement(value) {
    return String(Math.round(value * 10) / 10);
  }

  readMeasurements(form, unit) {
    const value = (name) => Number(form.querySelector(`input[name="${name}"]`)?.value);
    const lengthFactor = unit === 'in' ? 2.54 : 1;
    const weightFactor = unit === 'in' ? 0.45359237 : 1;
    return {
      bust: value('bust') * lengthFactor,
      waist: value('waist') * lengthFactor,
      hips: value('hips') * lengthFactor,
      height: value('height') * lengthFactor,
      weight: value('weight') * weightFactor,
    };
  }

  validateMeasurements(inputs) {
    const plausible = inputs.bust >= 30 && inputs.bust <= 220
      && inputs.waist >= 30 && inputs.waist <= 220
      && inputs.hips >= 30 && inputs.hips <= 240
      && inputs.height >= 100 && inputs.height <= 230
      && inputs.weight >= 25 && inputs.weight <= 300;
    if (!plausible) throw new Error(frFitText("ub50231b357bb", "Please check the measurement values and selected units before trying again."));
  }

  readChart(context, unit) {
    const source = context.querySelector(`[data-loving-size-chart-source="${unit}"]`);
    let matrix = [];
    if (source) {
      let sourceText = '';
      try {
        sourceText = JSON.parse(source.textContent || '""');
      } catch (_error) {
        sourceText = source.textContent || '';
      }
      matrix = String(sourceText).split(/\r?\n/).map((row) => row.trim()).filter(Boolean).map((row) => row.split('|').map((cell) => cell.trim()));
    } else {
      const wrap = context.querySelector(`[data-loving-size-guide-table="${unit}"]`);
      matrix = Array.from(wrap?.querySelectorAll('tr') || []).map((row) => Array.from(row.querySelectorAll('th, td')).map((cell) => cell.textContent || ''));
    }
    if (matrix.length < 2) throw new Error(frFitText("udf823f1107f0", "This product does not yet have enough chart data for an automatic recommendation."));

    const headings = matrix[0].map((cell) => this.classifyHeading(cell));
    const parsedRows = matrix.slice(1).map((cells) => {
      const measurements = {};
      headings.forEach((heading, index) => {
        if (!heading || heading === 'size') return;
        const range = this.parseRange(cells[index] || '');
        if (!range) return;
        measurements[heading] = this.toCanonicalRange(range, heading, unit);
      });
      return { size: String(cells[0] || '').trim(), measurements };
    }).filter((row) => row.size);

    if (parsedRows.length < 2) throw new Error(frFitText("u2383fbb73a53", "This product does not yet have enough chart rows for an automatic recommendation."));
    return parsedRows;
  }

  classifyHeading(value) {
    const heading = String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (!heading) return null;
    if (/\bsize\b/.test(heading)) return 'size';
    if (/bust|chest/.test(heading)) return 'bust';
    if (/waist/.test(heading)) return 'waist';
    if (/\bhips?\b/.test(heading)) return 'hips';
    if (/weight/.test(heading)) return 'weight';
    if (/garment length|floor length|hollow to hem|\blength\b/.test(heading)) return 'length';
    if (/recommended height|body height|person height|stature|\bheight\b/.test(heading)) return 'height';
    return null;
  }

  parseRange(value) {
    const numbers = String(value || '').replace(/,/g, '.').match(/\d+(?:\.\d+)?/g)?.map(Number).filter(Number.isFinite);
    if (!numbers?.length) return null;
    if (numbers.length === 1) return { min: numbers[0], max: numbers[0] };
    return { min: Math.min(numbers[0], numbers[1]), max: Math.max(numbers[0], numbers[1]) };
  }

  toCanonicalRange(range, type, unit) {
    if (unit === 'cm') return range;
    const factor = type === 'weight' ? 0.45359237 : 2.54;
    return { min: range.min * factor, max: range.max * factor };
  }

  readAvailability(context) {
    try {
      return JSON.parse(context.querySelector('[data-loving-size-availability]')?.textContent || '[]');
    } catch (_error) {
      return [];
    }
  }

  measurementTolerance() {
    return 1;
  }

  requiredIndexForMeasurement(rows, type, input) {
    const matchingIndex = rows.findIndex((row) => {
      const range = row.measurements[type];
      return input >= range.min && input <= range.max;
    });
    if (matchingIndex !== -1) return matchingIndex;

    const lastRange = rows.at(-1).measurements[type];
    if (input > lastRange.max + this.measurementTolerance(type)) return rows.length;

    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;
    rows.forEach((row, index) => {
      const range = row.measurements[type];
      const distance = input < range.min ? range.min - input : input > range.max ? input - range.max : 0;
      if (distance < nearestDistance - 0.0001 || Math.abs(distance - nearestDistance) <= 0.0001) {
        nearestIndex = index;
        nearestDistance = distance;
      }
    });
    return nearestIndex;
  }

  recommend(rows, inputs, availability) {
    const labels = { bust: frFitText("u66cd948de35c", "Bust"), waist: frFitText("u8470df662662", "Waist"), hips: frFitText("ub004098c1134", "Hips"), height: frFitText("ubfe2eca40179", "Height"), weight: frFitText("u81d27ef6d503", "Weight") };
    const candidateTypes = ['bust', 'waist', 'hips', 'height', 'weight'];
    const completeTypes = candidateTypes.filter((type) => rows.every((row) => row.measurements[type]));
    const sizingTypes = completeTypes.filter((type) => {
      const maxima = rows.map((row) => row.measurements[type].max);
      return Math.max(...maxima) - Math.min(...maxima) > 0.6;
    });

    if (!sizingTypes.length) throw new Error(frFitText("uc31b3953eab0", "This chart does not contain size-specific body measurements that the fit finder can compare."));

    const requiredByType = {};
    sizingTypes.forEach((type) => {
      requiredByType[type] = this.requiredIndexForMeasurement(rows, type, inputs[type]);
    });

    const requiredIndexes = Object.values(requiredByType);
    const recommendationIndex = Math.min(Math.max(...requiredIndexes), rows.length - 1);
    const recommendation = rows[recommendationIndex];
    const outsideChart = requiredIndexes.some((index) => index >= rows.length);
    const dominantType = sizingTypes.reduce((current, type) => {
      if (!current) return type;
      if (requiredByType[type] !== requiredByType[current]) return requiredByType[type] > requiredByType[current] ? type : current;
      const currentRatio = inputs[current] / rows[recommendationIndex].measurements[current].max;
      const nextRatio = inputs[type] / rows[recommendationIndex].measurements[type].max;
      return nextRatio > currentRatio ? type : current;
    }, null);

    const breakdown = sizingTypes.map((type) => {
      const requiredIndex = requiredByType[type];
      return { label: labels[type], size: requiredIndex >= rows.length ? frFitText("u7dfcf1f81063", "Above %{size}", {size: rows.at(-1).size}) : rows[requiredIndex].size };
    });

    const uniqueRequirements = new Set(requiredIndexes.map((index) => Math.min(index, rows.length - 1)));
    let copy = frFitText("ubb7ece9a931f", "Your measurements align most closely with size %{size}.", {size: recommendation.size});
    if (outsideChart) {
      copy = frFitText("ub8c218ac6837", "Your %{measurement} measurement is above the largest value in this chart. %{size} is the largest listed size, so contact us before ordering.", {measurement: labels[dominantType].toLowerCase(),size:recommendation.size});
    } else if (uniqueRequirements.size > 1) {
      const smaller = breakdown.filter((item) => item.label !== labels[dominantType]).map((item) => frFitText("u13b5904cc96b", "%{measurement} points to %{size}", {measurement:item.label.toLowerCase(),size:item.size})).join(', ');
      copy = frFitText("u581d024bc829", "%{measurement} needs %{size}%{details}. We recommend %{size} so the %{measurement} is not too tight; another area may fit looser.", {measurement:labels[dominantType],size:recommendation.size,details:smaller?frFitText('u25744b8d20ef',' while %{details}',{details:smaller}):''});
    }

    const sharedWarnings = completeTypes
      .filter((type) => !sizingTypes.includes(type))
      .filter((type) => inputs[type] > rows[0].measurements[type].max + this.measurementTolerance(type))
      .map((type) => frFitText("u6e74df6a92a0", "%{measurement} is above this chart's shared range.", {measurement:labels[type]}));

    const variant = this.resolveVariant(recommendation.size, availability);
    const notes = [];
    const contextualTypes = ['height', 'weight'].filter((type) => !sizingTypes.includes(type));
    if (contextualTypes.length) {
      const contextualLabels = contextualTypes.map((type) => labels[type]);
      const contextualText = contextualLabels.length === 2 ? `${contextualLabels[0]} ${frFitText('and','and')} ${contextualLabels[1]}` : contextualLabels[0];
      notes.push(frFitText("ub029c1d50c56", "%{measurements} provide fit context; the size changes only when this product chart has a size-specific range for those measurements.", {measurements:contextualText}));
    }
    notes.push(...sharedWarnings);
    if (!variant) notes.push(frFitText("uaca51704d573", "Size %{size} is not currently listed as a selectable option for this product.", {size:recommendation.size}));
    else if (!variant.available) notes.push(frFitText("u97c32f3b517c", "Size %{size} is currently unavailable.", {size:variant.label}));
    notes.push(frFitText("u9ab6c8bda97c", "This is a measurements-based draft estimate, not a fit guarantee. Contact us if measurements span several sizes or the order is for a fixed event date."));

    return { size: recommendation.size, copy, breakdown, notice: notes.join(' '), selectableVariant: variant?.available ? variant : null };
  }

  normalizeSizeLabel(value) {
    return String(value || '').toUpperCase().replace(/\bXXXXL\b/g, '4XL').replace(/\bXXXL\b/g, '3XL').replace(/\bXXL\b/g, '2XL').replace(/[^A-Z0-9]+/g, '');
  }

  sizeTokens(value) {
    const source = String(value || '').toUpperCase();
    const tokens = new Set([this.normalizeSizeLabel(source)]);
    source.split('/').forEach((part) => tokens.add(this.normalizeSizeLabel(part)));
    const usSize = source.match(/US\s*\d+W?/i)?.[0];
    if (usSize) tokens.add(this.normalizeSizeLabel(usSize));
    return Array.from(tokens).filter(Boolean);
  }

  resolveVariant(chartSize, availability) {
    const chartTokens = this.sizeTokens(chartSize);
    return availability.find((option) => this.sizeTokens(option.label).some((token) => chartTokens.includes(token))) || null;
  }

  renderRecommendation(context, recommendation) {
    const result = context.querySelector('[data-loving-size-result]');
    const breakdown = result.querySelector('[data-loving-size-breakdown]');
    const selectButton = result.querySelector('[data-loving-select-size]');
    result.querySelector('[data-loving-size-result-size]').textContent = recommendation.size;
    result.querySelector('[data-loving-size-result-copy]').textContent = recommendation.copy;
    result.querySelector('[data-loving-size-notice]').textContent = recommendation.notice;
    breakdown.replaceChildren(...recommendation.breakdown.map((item) => {
      const entry = document.createElement('li');
      entry.textContent = `${item.label} → ${item.size}`;
      return entry;
    }));

    if (recommendation.selectableVariant) {
      selectButton.textContent = frFitText("u84c62bc77f38", "Select size %{size}", {size:recommendation.selectableVariant.label});
      selectButton.dataset.lovingVariantSize = recommendation.selectableVariant.label;
      selectButton.hidden = false;
    } else {
      selectButton.hidden = true;
      delete selectButton.dataset.lovingVariantSize;
    }
    result.hidden = false;
    result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  selectRecommendedSize(button) {
    const size = button.dataset.lovingVariantSize;
    const picker = Array.from(document.querySelectorAll('variant-picker')).find((candidate) => (
      candidate.dataset.templateProductMatch === 'true'
      && !candidate.closest('product-card, quick-add-dialog')
    )) || document.querySelector('variant-picker');
    if (!size || !picker) return;
    const normalizedSize = this.normalizeSizeLabel(size);
    const radio = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name]')).find((input) => (
      ['size','talla','taille','größe','taglia','maat','tamanho','rozmiar','størrelse','storlek','koko','stærð','velikost','veľkosť','méret','mărime','размер','μέγεθος','veličina'].includes(input.dataset.optionName.toLowerCase())
      && this.normalizeSizeLabel(input.value) === normalizedSize
      && input.dataset.optionAvailable !== 'false'
    ));

    if (radio) {
      radio.click();
      return;
    }

    const select = Array.from(picker.querySelectorAll('select[name^="options["]')).find((candidate) => Array.from(candidate.options).some((option) => ["size","talla","taille","größe","taglia","maat","tamanho","rozmiar","størrelse","storlek","koko","stærð","velikost","veľkosť","méret","mărime","размер","μέγεθος","veličina"].includes(option.dataset.optionName?.toLowerCase())));
    const option = Array.from(select?.options || []).find((candidate) => this.normalizeSizeLabel(candidate.value) === normalizedSize);
    if (select && option && !option.disabled) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

const initializeLovingSizeGuide = () => {
  if (document.documentElement.dataset.lovingSizeGuideBuild === '2026-08-28-chart-boundaries-v2') return;
  document.documentElement.dataset.lovingSizeGuideBuild = '2026-08-28-chart-boundaries-v2';
  new LovingSizeGuide();
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeLovingSizeGuide, { once: true });
else initializeLovingSizeGuide();
